import React from 'react';
import PropTypes from 'prop-types';

export default function AddSkuPageDisclaimer({ disclaimer }) {
  return disclaimer ? <p className="p2 n700 marginTop-small1">{disclaimer}</p> : null;
}

AddSkuPageDisclaimer.propTypes = {
  disclaimer: PropTypes.string,
};

AddSkuPageDisclaimer.defaultProps = {
  disclaimer: null,
};
